import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/comfort")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Comfort, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Comfort & Kendall County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Comfort, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Comfort and Kendall County.",
      keywords: "awnings Comfort, awning company Comfort, custom awnings Comfort, sail shades Comfort, patio covers Comfort, pergola covers Comfort, metal awnings Comfort, canvas awnings Comfort, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Comfort", "Kendall County"),
  }),
  component: () => <CityHomePage city="Comfort" region="Kendall County" />,
});
